import * as React from 'react'

function SvgUserAccountMobileHeroBG(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg width="100%" height="100%" viewBox="0 0 376 526" fill="none" {...props}>
      <g>
        <path
          d="M375.119 8.698v517.026H.197V15.552c260.557-30.406 374.922-6.854 374.922-6.854z"
          fill="url(#prefix__paint0_radial)"
        />
        <path
          d="M375.119 8.698v517.026H.197V15.552c260.557-30.406 374.922-6.854 374.922-6.854z"
          fill="url(#prefix__paint1_radial)"
        />
      </g>
      <defs>
        <radialGradient
          id="prefix__paint0_radial"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-81.32 478.716 291.02) scale(822.439 530.647)"
        >
          <stop stopColor="#03CDFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
        <radialGradient
          id="prefix__paint1_radial"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-81.999 622.368 451.517) scale(1108.46 689.695)"
        >
          <stop stopColor="#03CDFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SvgUserAccountMobileHeroBG
